import React from 'react';
import { Typography } from '@saucelabs/ds-typography';
import { Button } from '@saucelabs/ds-button';
import { IconEnterpriseOutline } from '@saucelabs/ds-icons';

import { Card } from '../../Layout/Card';
import { SALES_CONTACT_FORM } from '../../../constants';
import Styles from './AdditionalPlanTile.styles';
import { trackEvent, EVENTS } from './../../../tracking';

const EnterprisePlansTile: React.FC = () => (
  <Card
    className={`${Styles['plan-tile']} ${Styles.enterprise} px-2.5 py-3 m-1 flex flex-col bg-right-bottom bg-no-repeat shadow-sm`}
  >
    <div className="flex flex-row justify-center text-white">
      <IconEnterpriseOutline className="fill-current text-white my-0.5" />
    </div>
    <Typography
      className="text-center font-bold text-white"
      disableSpacing
      variant="heading-4"
    >
      Enterprise Plans
    </Typography>
    <p className="mt-2 mb-5 leading-7 text-center text-white">
      Single-sign on (SSO), best-in-class support options, IPSEC secure tunnels,
      and a private device cloud option.
    </p>

    <div className="flex items-end flex-row-reverse mt-auto">
      <Button
        color="primary"
        onClick={() => {
          trackEvent(EVENTS.CONTACT_SALES, { type: 'plan-tile' });
          window.open(SALES_CONTACT_FORM, '_blank');
        }}
        variant="text"
      >
        Contact Sales
      </Button>
    </div>
  </Card>
);

export { EnterprisePlansTile };
